import { render, staticRenderFns } from "./moveform.vue?vue&type=template&id=7941a384&scoped=true&"
import script from "./moveform.vue?vue&type=script&lang=js&"
export * from "./moveform.vue?vue&type=script&lang=js&"
import style0 from "./moveform.vue?vue&type=style&index=0&id=7941a384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7941a384",
  null
  
)

export default component.exports